// Import only the components we need (directly from component files to avoid loading all of Flowbite)
import Drawer from 'flowbite/lib/esm/components/drawer';
import Dropdown from 'flowbite/lib/esm/components/dropdown';
import Accordion from 'flowbite/lib/esm/components/accordion';

document.addEventListener("DOMContentLoaded", function () {
  // Initialize Drawers (mobile filter panels)
  const drawerElements = document.querySelectorAll('[data-drawer-target]');
  const drawers = new Map(); // Store drawer instances

  drawerElements.forEach(button => {
    const targetId = button.getAttribute('data-drawer-target');
    const drawerEl = document.getElementById(targetId);

    if (drawerEl) {
      const options = {
        placement: 'left',
        backdrop: true,
        bodyScrolling: button.getAttribute('data-drawer-body-scrolling') === 'true',
        edge: false,
        edgeOffset: '',
        backdropClasses: 'bg-gray-900/50 fixed inset-0 z-30',
      };

      const drawer = new Drawer(drawerEl, options);
      drawers.set(targetId, drawer);

      // Attach event listener for show button
      if (button.hasAttribute('data-drawer-show')) {
        button.addEventListener('click', () => {
          drawer.show();
        });
      }
    }
  });

  // Handle hide buttons (close buttons inside drawers)
  const drawerHideButtons = document.querySelectorAll('[data-drawer-hide]');
  drawerHideButtons.forEach(button => {
    const targetId = button.getAttribute('data-drawer-hide');
    button.addEventListener('click', () => {
      const drawer = drawers.get(targetId);
      if (drawer) {
        drawer.hide();
      }
    });
  });

  // Initialize Dropdowns (filter menus)
  const dropdownTriggers = document.querySelectorAll('[data-dropdown-toggle]');
  dropdownTriggers.forEach(trigger => {
    const targetId = trigger.getAttribute('data-dropdown-toggle');
    const dropdownEl = document.getElementById(targetId);

    if (dropdownEl) {
      const placement = trigger.getAttribute('data-dropdown-placement') || 'bottom';

      const options = {
        placement: placement,
        triggerType: 'click',
        offsetSkidding: 0,
        offsetDistance: 10,
        delay: 300,
      };

      new Dropdown(dropdownEl, trigger, options);
    }
  });

  // Initialize Accordions (collapsible filter sections)
  const accordionElements = document.querySelectorAll('[data-accordion]');
  accordionElements.forEach(accordionEl => {
    const accordionType = accordionEl.getAttribute('data-accordion') || 'collapse';

    const items = [];
    const accordionItems = accordionEl.querySelectorAll('[data-accordion-target]');

    accordionItems.forEach(trigger => {
      const targetId = trigger.getAttribute('data-accordion-target');
      const targetEl = document.querySelector(targetId);

      if (targetEl) {
        items.push({
          id: targetId.replace('#', ''),
          triggerEl: trigger,
          targetEl: targetEl,
          active: trigger.getAttribute('aria-expanded') === 'true',
        });
      }
    });

    if (items.length > 0) {
      const options = {
        alwaysOpen: accordionType === 'open',
        activeClasses: 'bg-gray-100 dark:bg-gray-800 text-gray-900 dark:text-white',
        inactiveClasses: 'text-gray-500 dark:text-gray-400',
      };

      new Accordion(accordionEl, items, options);
    }
  });

  // Initialize Collapse toggles (for drawer filter sections)
  const collapseToggles = document.querySelectorAll('[data-collapse-toggle]');
  collapseToggles.forEach(trigger => {
    const targetId = trigger.getAttribute('data-collapse-toggle');
    const targetEl = document.getElementById(targetId);

    if (targetEl) {
      trigger.addEventListener('click', () => {
        targetEl.classList.toggle('hidden');
      });
    }
  });
});
